import { CustomCellRendererProps } from "ag-grid-react";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { AuditLogMaintenanceConstant } from "./AuditLogMaintenanceConstant";

const SCREEN_CONSTANT = AuditLogMaintenanceConstant;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const INITIAL_COMMON_AUDIT_LOG_COL_DEF: any[] = [
    {
        headerName: SCREEN_CONSTANT.UPDATED_DATE,
        field: "updatedDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
        dataType: "dateTime"

    },
    {
        headerName: SCREEN_CONSTANT.CNTR_NO,
        field: "cntrNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.CHARGE_TYPE,
        field: "chargeType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.SUB_CHARGE_TYPE,
        field: "subChargeType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.OPS_LINE,
        field: "opsLine",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.PROPOSAL_NO,
        field: "proposalNo",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.USER_ID,
        field: "userId",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.BILL_OF_LADING,
        field: "billOfLading",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.SHIPPING_BILL,
        field: "shippingBill",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.FORWARDER_CODE,
        field: "forwarderCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
];
export const INITIAL_CHARGE_AUDIT_LOG_COL_DEF: any[] = [
    ...INITIAL_COMMON_AUDIT_LOG_COL_DEF,
    {
        headerName: SCREEN_CONSTANT.DTL_STATE_BF,
        field: "dtlStateBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.DTL_STATE_AF,
        field: "dtlStateAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.BILL_TO_COMPANY_BF,
        field: "billToCompanyBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.BILL_TO_COMPANY_AF,
        field: "billToCompanyAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.CHARGE_ON_COMPANY_BF,
        field: "chargeOnCompanyBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.CHARGE_ON_COMPANY_AF,
        field: "chargeOnCompanyAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.AUDIT_LOG_INCIDENT,
        field: "auditLogIncident",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 400,
    },
].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const INITIAL_WAIVER_AUDIT_LOG_COL_DEF: any[] = [
    ...INITIAL_COMMON_AUDIT_LOG_COL_DEF,
    {
        headerName: SCREEN_CONSTANT.DTL_STATE_BF,
        field: "dtlStateBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.DTL_STATE_AF,
        field: "dtlStateAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.AUDIT_LOG_INCIDENT,
        field: "auditLogIncident",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 400,
    },
].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const INITIAL_COLLECTION_AUDIT_LOG_COL_DEF: any[] = [
    {
        headerName: SCREEN_CONSTANT.UPDATED_DATE,
        field: "updatedDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
        dataType: "dateTime"
    },
    {
        headerName: SCREEN_CONSTANT.USER_ID,
        field: "userId",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.DRAFT_DOC_NO_BF,
        field: "draftDocNoBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.DRAFT_DOC_NO_AF,
        field: "draftDocNoAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.DOC_NO_BF,
        field: "docNoBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.DOC_NO_AF,
        field: "docNoAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.RECEIPT_NO_BF,
        field: "receiptNoBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.RECEIPT_NO_AF,
        field: "receiptNoAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.AUDIT_LOG_INCIDENT,
        field: "auditLogIncident",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 400,
    },
].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const INITIAL_COMPANY_AUDIT_LOG_COL_DEF: any[] = [
    {
        headerName: SCREEN_CONSTANT.UPDATED_DATE,
        field: "updatedDateTime",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
        dataType: "dateTime"
    },
    {
        headerName: SCREEN_CONSTANT.USER_ID,
        field: "userId",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.CONSORTIUM_CODE,
        field: "consortiumCodeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.VESSEL_CODE,
        field: "vesselCodeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.VOYAGE_CODE,
        field: "voyageCodeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.CALCULATION_BASIS,
        field: "fspCalculateMethodAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.COMPANY_CODE_BF,
        field: "companyCodeBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.COMPANY_CODE_AF,
        field: "companyCodeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.PRIORITY_BF,
        field: "priorityBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.PRIORITY_AF,
        field: "priorityAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.STATUS_BF,
        field: "statusBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.STATUS_AF,
        field: "statusAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.SHIPPING_LINE_BF,
        field: "ownerBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.SHIPPING_LINE_AF,
        field: "ownerAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.EFFECTIVE_DATE_FROM_BF,
        field: "effectiveDateFromBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
        dataType: "date"
    },
    {
        headerName: SCREEN_CONSTANT.EFFECTIVE_DATE_FROM_AF,
        field: "effectiveDateFromAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
        dataType: "date"
    },
    {
        headerName: SCREEN_CONSTANT.EFFECTIVE_DATE_TO_BF,
        field: "effectiveDateToBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
        dataType: "date"
    },
    {
        headerName: SCREEN_CONSTANT.EFFECTIVE_DATE_TO_AF,
        field: "effectiveDateToAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
        dataType: "date"
    },
    {
        headerName: SCREEN_CONSTANT.SERVICE_CODE_BF,
        field: "serviceCodeBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.SERVICE_CODE_AF,
        field: "serviceCodeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.FORWARDER_CODE_BF,
        field: "forwarderCodeBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 420,
    },
    {
        headerName: SCREEN_CONSTANT.FORWARDER_CODE_AF,
        field: "forwarderCodeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 420,
    },
    {
        headerName: SCREEN_CONSTANT.AGENT_CODE_BF,
        field: "agentCodeBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.AGENT_CODE_AF,
        field: "agentCodeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.CARGO_CODE_BF,
        field: "cargoCodeBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.CARGO_CODE_AF,
        field: "cargoCodeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.FSP_COUNTING_FROM_BF,
        field: "fspCountingFromBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.FSP_COUNTING_FROM_AF,
        field: "fspCountingFromAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.FSP_COUNTING_TO_BF,
        field: "fspCountingToBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.FSP_COUNTING_TO_AF,
        field: "fspCountingToAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.GRACE_HOUR_TO_BF,
        field: "graceHourToBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.GRACE_HOUR_TO_AF,
        field: "graceHourToAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.GRACE_HOUR_FROM_BF,
        field: "graceHourFromBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.GRACE_HOUR_FROM_AF,
        field: "graceHourFromAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.GRACE_MINUTE_TO_BF,
        field: "graceMinuteToBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.GRACE_MINUTE_TO_AF,
        field: "graceMinuteToAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 420,
    },
    {
        headerName: SCREEN_CONSTANT.GRACE_MINUTE_FROM_BF,
        field: "graceMinuteFromBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 420,
    },
    {
        headerName: SCREEN_CONSTANT.GRACE_MINUTE_FROM_AF,
        field: "graceMinuteFromAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 420,
    },
    {
        headerName: SCREEN_CONSTANT.SHIPMENT_TYPE_BF,
        field: "shipmentTypeBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.SHIPMENT_TYPE_AF,
        field: "shipmentTypeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.FSP_COUNTING_DIRECTION_BF,
        field: "fspCountingDirectionBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.FSP_COUNTING_DIRECTION_AF,
        field: "fspCountingDirectionAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.FSP_DAYS_BF,
        field: "firstTierFspBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.FSP_DAYS_AF,
        field: "firstTierFspAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.FSP_UOM_BF,
        field: "fspUomBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.FSP_UOM_AF,
        field: "fspUomAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.CHARGE_TYPE_BF,
        field: "chargeTypeBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.CHARGE_TYPE_AF,
        field: "chargeTypeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.SUB_CHARGE_TYPE_BF,
        field: "subChargeTypeBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.SUB_CHARGE_TYPE_AF,
        field: "subChargeTypeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.CNTR_MOVEMENT_BF,
        field: "cntrMovementBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.CNTR_MOVEMENT_AF,
        field: "cntrMovementAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.CNTR_STATUS_BF,
        field: "cntrStatusBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.CNTR_STATUS_AF,
        field: "cntrStatusAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.CUSTOMER_TYPE_BF,
        field: "customerTypeBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 420,
    },
    {
        headerName: SCREEN_CONSTANT.CUSTOMER_TYPE_AF,
        field: "customerTypeAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 420,
    },
    {
        headerName: SCREEN_CONSTANT.FORWARDER_REF_BF,
        field: "forwarderReferenceBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 380,
    },
    {
        headerName: SCREEN_CONSTANT.FORWARDER_REF_AF,
        field: "forwarderReferenceAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.APPLY_CALENDAR_ADJ_BF,
        field: "applyCalendarAdjBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.APPLY_CALENDAR_ADJ_AF,
        field: "applyCalendarAdjAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.SPLIT_FIRST_DAYS_BF,
        field: "splitFirstDaysBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.SPLIT_FIRST_DAYS_AF,
        field: "splitFirstDaysAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.SPLIT_FIRST_DAYS_TO_BF,
        field: "splitFirstDaysToBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.SPLIT_FIRST_DAYS_TO_AF,
        field: "splitFirstDaysToAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.SPLIT_REMAIN_DAYS_TO_BF,
        field: "splitRemainDaysToBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.SPLIT_REMAIN_DAYS_TO_AF,
        field: "splitRemainDaysToAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.REJECT_REASON_BF,
        field: "rejectReasonBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.REJECT_REASON_AF,
        field: "rejectReasonAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.REMARKS_BF,
        field: "remarksBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.REMARKS_AF,
        field: "remarksAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.GRACE_EXTEND_BF,
        field: "graceExtendBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.GRACE_EXTEND_AF,
        field: "graceExtendAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 360,
    },
    {
        headerName: SCREEN_CONSTANT.ACTIVE_IND_BF,
        field: "activeIndBf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.ACTIVE_IND_AF,
        field: "activeIndAf",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 320,
    },
    {
        headerName: SCREEN_CONSTANT.AUDIT_LOG_INCIDENT,
        field: "auditLogIncident",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 400,
    },
].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const transferRowData = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};

    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}

